import { nanoid } from 'nanoid';

// JAVA SPRING PROJECTS
const advancedJavaData = [
  {
    id: nanoid(),
    img: 'quote-generator.png',
    title: 'Quote Generator',
    info: 'This was one of my first projects. It is a single-page web application that retrieves random quotes from an API and allows users to share them on Twitter.',
    info2: '',
    url: 'https://shcoobz.github.io/quote-generator/',
    repo: 'https://github.com/Shcoobz/quote-generator',
  },
  {
    id: nanoid(),
    img: 'infinity-scroll.png',
    title: 'Infinity Scroll',
    info: 'This web application uses the Unsplash API to provide an infinite scroll of random images. As the user scrolls down, it continuously loads more images for an endless visual experience.',
    info2: '',
    url: 'https://shcoobz.github.io/infinite-scroll/',
    repo: 'https://github.com/Shcoobz/infinite-scroll',
  },
  {
    id: nanoid(),
    img: 'picture-in-picture.png',
    title: 'Picture in picture',
    info: 'This web application is an interactive tool designed to create a user-friendly interface where users can play a video in Picture in Picture mode, allowing them to watch video content while interacting with other applications or websites.',
    info2: '',
    url: 'https://shcoobz.github.io/picture-in-picture/',
    repo: 'https://github.com/Shcoobz/picture-in-picture',
  },
  // {
  //   id: nanoid(),
  //   img: '',
  //   title: '',
  //   info: '',
  //   info2: '',
  //   url: '',
  //   repo: '',
  // },
];

export default advancedJavaData;
